export async function getCustomerCountry(): Promise<string> {
    try {
      const response = await fetch("/api/country");
      if (!response.ok) throw new Error("Failed to fetch country");
      const data = await response.json();
      return data.country || "Unknown";
    } catch (error) {
      console.error(error);
      return "Unknown";
    }
  }
  